import axiosInstance from "./axiosInstance";
import { url } from "./url";
// 🎮 Fetch games by category with pagination
export const fetchGamesByCategory = async (categoryId, skip = 0, limit = 100) => {
  try {
    const payload = {
      skip,
      limit,
      html5Category: categoryId,
      sortby: "order",
      sort: "asc",
    };
    const response = await axiosInstance.post(`${url.apiUrl}web/html5-games/newlist`, payload);
    return response.data || null;
  } catch (error) {
    console.error("Error fetching games by category:", error);
    return null;
  }
};
export const fetchTopPlayedGames = async (skip = 0, limit = 100) => {
  try {
    const payload = {
      skip,
      limit,
    };

    const res = await axiosInstance.post(`${url.apiUrl}web/html5-games/topgamelist`, payload);

    return res.data?.list?.slice(0, 10) || [];
  } catch (error) {
    console.error("Error fetching topgamelist:", error);
    return null;
  } }
// 🧩 Fetch paginated HTML5 categories
export const fetchHtml5Categories = async ({ skip = 0, limit = 3 } = {}) => {
  try {
    const response = await axiosInstance.post(`${url.apiUrl}web/html5-categories/list`, {
      sortby: "order",
      sort: "asc",
      skip,
      limit,
    });
    return response.data || null;
  } catch (error) {
    console.error("Error fetching categories:", error);
    return null;
  }
};

// 📄 Get game details by ID
export const fetchGameDetailById = async (gameId) => {
  try {
    const response = await axiosInstance.get(`${url.apiUrl}web/html5-games/details/${gameId}`);
    return response.data?.data || null;
  } catch (error) {
    console.error("Error fetching game detail:", error);
    return null;
  }
};

// 👁️ Update game view tracking (start/end)
export const updateGameView = async ({ html5Category, htmlGame, status = "start" }) => {
  try {
    const response = await axiosInstance.post(`${url.apiUrl}web/html5-games/update-view`, {
      html5Category,
      htmlGame,
      status,
    });
    return response.data || null;
  } catch (error) {
    console.error("Failed to update game view:", error);
    return null;
  }
};

// 👤 Track guest play session
export const trackGuestPlayAPI = async (payload) => {
  try {
    const response = await axiosInstance.post(`${url.apiUrl}web/html5-games/track-guest-play`, payload);
    return response.data || null;
  } catch (error) {
    console.error("Failed to track guest play:", error);
    return null;
  }
};
